import {ApiClient} from '@hconnect/apiclient'

import {RequestFunc, ReferenceLinks} from '../../types'

import {loggingDecorator} from './decorators'

const getRefLinksImpl: RequestFunc<void, ReferenceLinks[]> = async () => {
  const {data} = await ApiClient.axiosInstance.get<ReferenceLinks[]>(
    '/pom-questionnaires/docs-links'
  )
  return data
}

export const getRefLinks = loggingDecorator(getRefLinksImpl)

const getDocsLinkImpl: RequestFunc<void, string> = async () => {
  const {data} = await ApiClient.axiosInstance.get<string>('/pom-questionnaires/docs-link')
  return data
}

export const getDocsLink = loggingDecorator(getDocsLinkImpl)
